import { displayscreenType, gatewayType } from '@/utils/convert'
import { sensorType } from '@/utils/dict/sensor'

/**
 * 前端自定义icon整合
 * author:brian
 * date:2022 06 02
 */

// 预留一个对象形式设置  后期可能会需要title等的设置
// 监测点类型icon
export const carrierIcon = {
  1: {
    icon: 'iconfont icon-weibolu-xian',
    title: $t('integration.heat_insulation_box')
  },
  2: {
    icon: 'iconfont icon-bingxiang',
    title: $t('integration.refrigerator')
  },
  3: {
    icon: 'iconfont icon-qiche',
    title: $t('integration.vehicle')
  },
  4: {
    icon: 'iconfont icon-9lengku',
    title: $t('integration.cold_storage')
  }
}

// 设备在线状态的icon
export const deviceStatusIcon = {
  0: {
    icon: 'iconfont icon-wu-WiFi',
    title: $t('integration.off-line')
  },
  1: {
    icon: 'iconfont icon-wifi',
    title: $t('integration.on-line')
  },
  2: {
    icon: 'el-icon-video-play',
    title: $t('integration.deactivate')
  }
}

// 设备类型icon 具体到什么设备
export const deviceTypeIcon = {
  sensor: sensorType,
  gateway: gatewayType,
  dispaly: displayscreenType,
  relay: displayscreenType
}

// 异常icon
export const abIcon = {
  0: {
    icon: 'el-icon-warning',
    title: $t('integration.abnormal_sensor_connection')
  },
  1: {
    icon: 'el-icon-error',
    title: $t('integration.abnormal_sensor_temperature')
  },
  2: {
    icon: 'el-icon-warning-outline',
    title: $t('integration.abnormal_sensor_humidity')
  },
  3: {
    icon: 'el-icon-circle-close',
    title: $t('integration.gateway_connection_exception')
  },
  4: {
    icon: 'el-icon-close',
    title: $t('integration.gateway_power_failure_exception')
  },
  5: {
    icon: 'el-icon-no-smoking',
    title: $t('integration.abnormal_connection_of_display_screen')
  },
  6: {
    icon: 'el-icon-s-operation',
    title: $t('integration.abnormal_relay_connection')
  },
  7: {
    icon: 'el-icon-message-solid',
    title: $t('integration.retention_exception')
  }
}
// 运行状态
export const RunStatus = [
  {
    value: '',
    icon: 'el-icon-thumb',
    label: 'integration.please_select'
  },
  {
    value: 0,
    icon: 'iconfont icon-wu-WiFi',
    label: 'integration.off-line'
  },
  {
    value: 1,
    icon: 'iconfont icon-wifi',
    label: 'integration.on-line'
  }
]

// 设备类型 --目录级别

export const deviceType = {
  0: {
    icon: 'iconfont icon-chuanganqi1',
    title: $t('integration.sensor')
  },
  1: {
    icon: 'iconfont icon-wangguan',
    title: $t('integration.gateway')
  },
  2: {
    icon: 'iconfont icon-lcd ',
    title: $t('integration.display')
  },
  3: {
    icon: 'el-icon-s-operation ',
    title: $t('integration.relay')
  },
  // 后续如果有新增的 则继续添加
  5: {
    icon: 'iconfont icon-qiti',
    title: $t('route.gas')
  },
  6: {
    icon: 'iconfont icon-menci',
    title: $t('route.magnetism')
  }
}
// 设备类型 --tabs

export const deviceTypeIconArray = [
  {
    id: '0',
    icon: 'iconfont icon-chuanganqi1',
    title: $t('integration.sensor')
  },
  {
    id: '1',
    icon: 'iconfont icon-wangguan',
    title: $t('integration.gateway')
  },
  {
    id: '2',
    icon: 'iconfont icon-lcd ',
    title: $t('integration.display')
  },
  {
    id: '3',
    icon: 'el-icon-s-operation ',
    title: $t('integration.relay')
  },
  // 后续如果有新增的 则继续添加
  // 气体和门磁
  {
    id: '5',
    icon: 'iconfont icon-qiti',
    title: $t('route.gas')
  },
  {
    id: '6',
    icon: 'iconfont icon-menci',
    title: $t('route.magnetism')
  },
]
